/**
 * Supabase client singleton for authentication and database operations
 */

import { createClient } from '@supabase/supabase-js';

// Get Supabase credentials from environment variables
// Note: In Cloudflare Pages, use REACT_APP_ prefix for client-side variables
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder-key';

// Create a single supabase client for interacting with your database
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true, // Enable session persistence in localStorage
    autoRefreshToken: true, // Automatically refresh tokens
    detectSessionInUrl: true, // Detect OAuth callback URLs
  },
});

/**
 * Anonymous Supabase client for public tables (fonts, etc.).
 * Uses in-memory-only auth storage so a stale user JWT is never sent —
 * avoids "JWT issued at future" when the client clock is ahead of Supabase.
 */
export const supabasePublic = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false,
    storageKey: 'layerre-public-anonymous',
    storage: {
      getItem: () => null,
      setItem: () => {},
      removeItem: () => {},
    },
  },
});

// Helper to check if Supabase is properly configured
export function isSupabaseConfigured(): boolean {
  return (
    supabaseUrl !== 'https://placeholder.supabase.co' &&
    supabaseAnonKey !== 'placeholder-key'
  );
}
